<template>
  <article :class="['balance-card__wrapper', { 'balance-card__wrapper_warning': lowBalance }]">
    <div class="mb-2">
      <div class="balance-card__balance-title">
        ВАШ БАЛАНС
      </div>
      <div class="balance-card__balance">
        {{ formattedBalance }}
      </div>
    </div>
    <v-btn
      depressed
      :class="['balance-card__btn', { 'balance-card__btn_warning': lowBalance }]"
      @click="goToTopup"
    >
      <font-awesome-icon icon="plus" /> Пополнить
    </v-btn>
    <v-snackbar v-model="errorSnackbar" color="error" timeout="3000">
      Не удалось обновить данные платёжного аккаунта
    </v-snackbar>
  </article>
</template>

<script>
  import { mapState } from 'vuex'
  import RouteName from '@/models/enums/RouteName'

  export default {
    name: 'BalanceCard',
    data () {
      return {
        errorSnackbar: false,
      }
    },
    computed: {
      ...mapState('billing', ['paymentAccount']),
      formattedBalance () {
        if (this.paymentAccount.balance === null) return '—'
        return this.$options.filters.amountWithCurrency0(this.paymentAccount.balance)
      },
      // Блокировка или уход в минус — карточка становится тревожной
      lowBalance () {
        return this.paymentAccount.blocked || this.paymentAccount.balance < 0
      },
    },
    created () {
      this.$store.dispatch('billing/fetchPaymentAccount').catch(() => {
        this.errorSnackbar = true
      })
    },
    methods: {
      goToTopup () {
        this.$router.push({ name: RouteName.BillingTopup })
      },
    },
  }
</script>

<style scoped lang="less">
.balance-card {
  &__wrapper {
    border: 2px solid #E1CD9D;
    border-radius: 5px;
    background-color: #FFF3D6;
    padding: 8px 10px;

    &_warning {
      border-color: #9E1F48;
      background-color: #EA306B;
      color: #fff;
    }
  }

  &__balance {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.2;
  }

  &__btn {
    width: 100%;
    background-color: @color-primary !important;
    color: #fff;
    border-radius: 5px;
    font-weight: normal;
    font-size: 14px;

    &_warning {
      color: #000;
      background-color: #fff !important;
    }

    svg {
      height: 14px;
      margin-right: 8px;
      margin-bottom: 2px;
    }
  }
}
</style>
